import { toDateShort } from '@monetize/utils/core';
import { addDays } from 'date-fns/addDays';
import { addMonths } from 'date-fns/addMonths';
import { endOfDay } from 'date-fns/endOfDay';
import { formatISO } from 'date-fns/formatISO';
import { parseISO } from 'date-fns/parseISO';
import { startOfDay } from 'date-fns/startOfDay';
import { useMemo, useRef } from 'react';
import { MBox } from '../../../../components/Monetize';
import DataTableActions, {
  ActionType,
} from '../../../../components/Monetize/DataTable/MDataTableActions';

interface UsageTableFilterActionsProps {
  currentUsagePeriodStart: string;
  onChange: (startTime: string, endTime: string) => void;
}

/**
 * Show each usage billing period as a quick filter action
 */
export const UsageTableFilterActions = ({
  currentUsagePeriodStart,
  onChange,
}: UsageTableFilterActionsProps) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const dateRanges = useMemo((): ActionType[] => {
    const startDate = startOfDay(parseISO(currentUsagePeriodStart));
    return new Array(12).fill(0).map((_, i) => {
      const monthStart = addMonths(startDate, -i);
      const monthEnd = addDays(endOfDay(addMonths(monthStart, 1)), -1);
      return {
        title: `${toDateShort(monthStart)} - ${toDateShort(monthEnd)}`,
        enabled: true,
        action: () => {
          onChangeRef.current(formatISO(monthStart), formatISO(monthEnd));
        },
      } satisfies ActionType;
    });
  }, [currentUsagePeriodStart]);

  return (
    <MBox ml={1}>
      <DataTableActions actions={dateRanges} />
    </MBox>
  );
};
